/**
 * Resize Listener
 * debounces window size changes
 *
 * When width changes, sends event "lichen:resize"
 * Any component can listen to event and adjust to new size: e.detail.width
 *
 * When height changes, sets --vh custom property
 * Any component can use this property to match height to viewportHeight (needed for iOS)
 */

var initializeResizeListener = function () {
	var setHeight = function (height) {
		// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
		var vh = height * 0.01;

		// Then we set the value in the --vh custom property to the root of the document
		document.documentElement.style.setProperty('--vh', vh + 'px');
	};
	setHeight(window.innerHeight);

	var lichenResizeTimer = false;
	var lastWidth = window.innerWidth;
	var lastHeight = window.innerHeight;

	window.addEventListener(
		'resize',
		function () {
			clearTimeout(lichenResizeTimer);

			lichenResizeTimer = setTimeout(function () {
				var width = window.innerWidth;
				var height = window.innerHeight;

				if (lastWidth !== width || lastHeight !== height) {
					// width or height changed
					var event = new CustomEvent('lichen:window-resize', { detail: { width: width, height: height } });
					document.dispatchEvent(event);
				}

				if (lastWidth !== width) {
					// width changed
					lastWidth = width;
					var event = new CustomEvent('lichen:resize', { detail: { width: width } });
					document.dispatchEvent(event);
				}

				if (lastHeight !== height) {
					// height changed
					setHeight(height);
					lastHeight = height;
				}
			}, 300);
		},
		false
	);
};

document.addEventListener('lichen:loaded', initializeResizeListener);

export default initializeResizeListener;
